import AiTier from "./AiTier";

export interface AiSettingsAiAttribute {
    id?: string;
    name?: string;
}

export class AiSettingsAutorunSystemExtractor {
    constructor(
        public id?: string,
        public name?: string,
        public aiAttributes?: AiSettingsAiAttribute[]
    ) {
        //
    }

    public static fromPOJO(data: any) {
        return new AiSettingsAutorunSystemExtractor(
            data.id,
            data.name,
            data.aiAttributes ?? []
        );
    }
}

class AiSettings {
    constructor(
        public autoRunSystemAiExtractorsOnOrganizationSources?: boolean,
        public autorunSystemExtractors?: AiSettingsAutorunSystemExtractor[]
    ) {
        //
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const autorunSystemExtractors = data.autorunSystemExtractors ?? [];

        return new AiSettings(
            data.autoRunSystemAiExtractorsOnOrganizationSources,
            autorunSystemExtractors.map((extractor: any) => AiSettingsAutorunSystemExtractor.fromPOJO(extractor))
        );
    }
}

export class OrganizationAiSettings {
    constructor(
        public organizationId?: string,
        public organizationName?: string,
        public organizationFriendlyId?: string,
        public aiFeatureEnabled?: boolean,
        public aiTier?: AiTier,
        public creditsUsedThisMonth?: number,
        public settings?: AiSettings | null
    ) {
        //
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        return new OrganizationAiSettings(
            data.organizationId,
            data.organizationName,
            data.organizationFriendlyId,
            data.aiFeatureEnabled,
            AiTier.fromPOJO(data.aiTier),
            data.creditsUsedThisMonth,
            AiSettings.fromPOJO(data.settings)
        );
    }
}

export default AiSettings;
